import React from "react"
import Select from "react-select"

import SelectTags from "../../common/tags/SelectTags"

import {
    topicTypes,
    topicDimensionStatuses
} from "../../../config/application-definitions"

const allTopicTypes = topicTypes.map(type => ({
    id: type.name,
    name: type.name
}))

const allStatuses = topicDimensionStatuses.map(status => ({
    id: status,
    name: status
}))

const InsightAreaFilterForm = ({ model, onEventChange, onValueChange }) => (
    <form name="filterform">
        <div className="filter-block">
            <label htmlFor="insight-area-filter-name">Name</label>
            <input
                id="insight-area-filter-name"
                type="text"
                className="form-control"
                name="name"
                value={model.name}
                onChange={onEventChange}
            />
        </div>
        <div className="filter-block">
            <label htmlFor="insight-area-filter-types">Types</label>
            <SelectTags
                name="types"
                value={model.types}
                options={allTopicTypes}
                SelectComponent={Select}
                onChange={onValueChange("types")}
            />
        </div>
        <div className="filter-block">
            <label htmlFor="insight-area-filter-statuses">Statuses</label>
            <SelectTags
                name="statuses"
                value={model.statuses}
                options={allStatuses}
                SelectComponent={Select}
                onChange={onValueChange("statuses")}
            />
        </div>
        <div className="form-check">
            <label className="form-check-label">
                <input
                    className="form-check-input"
                    name="empty"
                    type="checkbox"
                    checked={model.empty}
                    onChange={onEventChange}
                />&nbsp; Only insight areas without mappings
            </label>
        </div>
    </form>
)

export default InsightAreaFilterForm
